import EditorMarker, { MarkerType } from './EditorMarker';
import PlatformContainer from './PlatformContainer';
import PlatformImage from './platforms/PlatformImage';

export default class EditorPlatformMarker extends EditorMarker {
  public classType: (typeof PlatformImage | typeof PlatformContainer) | undefined;
  public isMovingPlatform: boolean;

  constructor(scene: Phaser.Scene, x: number = 0, y: number = 0) {
    super(scene, x, y);

    this.markerType = MarkerType.Platform;
    this.isMovingPlatform = false;
  }
}
